const GET_BOT_RESPONSE = (state, botmsg) => {
  state.botmsg = botmsg;
};

export default {
  GET_BOT_RESPONSE
};



// WEBPACK FOOTER //
// ./src/store/modules/teachbot/mutations.js